import { render, staticRenderFns } from "./PopupStaffAdd.vue?vue&type=template&id=66ea537c&scoped=true"
import script from "./PopupStaffAdd.vue?vue&type=script&lang=js"
export * from "./PopupStaffAdd.vue?vue&type=script&lang=js"
import style0 from "./PopupStaffAdd.vue?vue&type=style&index=0&id=66ea537c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea537c",
  null
  
)

export default component.exports